import { useEffect, useState } from "react";
import DivStyle from "../../components/style/div.component";
import Table from "../../components/table/Table";
import Page from "../../components/table/paging";
import AdminAPI from "../../api/admin";
import GAMEAPI from "../../api/game";
import CafePagingTable from "../../components/table/CafePagingTable";
import { Icon } from "@mdi/react";
import InputFormStyle from "../../components/style/input_form.component";
import { mdiMagnify } from "@mdi/js";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import { Header } from "../../components/table/interface/interface";
import ButtonStyle from "../../components/style/button.component";

interface UserGamePointResponse {
  userId: number;
  uid: string;
  nickname: string;
  point: number;
  rebuyinTicket: number;
}

enum SearchOption {
  UID = "uid",
  NICKNAME = "nickname",
  USERID = "userId",
}

const UserGamePoint = () => {
  const [dataList, setDataList] = useState<UserGamePointResponse[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchOption, setSearchOption] = useState<SearchOption>(
    SearchOption.NICKNAME
  );
  const [searchText, setSearchText] = useState("");
  const [totalSize, setTotalSize] = useState(0);
  const headers = [
    { text: "유저 id", align: "center", sortable: false, value: "userId" },
    { text: "닉네임", align: "center", sortable: false, value: "nickname" },
    { text: "GP", align: "center", sortable: false, value: "point" },
  ];

  const exportToExcel = async (headers: Header[], items: any[]) => {
    const today = new Date().toISOString().split("T")[0];
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Data");

    worksheet.addRow(headers.map((header) => header.text));
    items.forEach((item: any) => {
      const rowValues = headers.map((header) => item[header.value]);
      worksheet.addRow(rowValues);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    FileSaver.saveAs(blob, `all_report_${today}.xlsx`);
  };

  const getDatas = async () => {
    const res = await GAMEAPI.getUserGamePointList(
      currentPage - 1,
      searchOption,
      searchText
    );
    if (res) {
      const totalPages = Math.ceil(res.totalCount / 20);
      const updatedDataList = res.list.map((item: any) => ({
        ...item,
        point: item.point.toLocaleString(),
      }));
      setTotalSize(res.totalCount);
      setTotalPages(totalPages);
      setDataList(updatedDataList);
    }
  };

  const getAllData = async () => {
    let allData: UserGamePointResponse[] = [];
    let page = 0;
    let hasMore = true;

    while (hasMore) {
      const res = await GAMEAPI.getUserGamePointList(
        page,
        searchOption,
        searchText
      );
      if (res && res.list.length > 0) {
        const updatedData = res.list.map((item: any) => ({
          ...item,
          point: item.point.toLocaleString(),
        }));
        allData = [...allData, ...updatedData];
        page++;
        hasMore = res.list.length === 20;
      } else {
        hasMore = false;
      }
    }
    return allData;
  };

  const handleExportAllToExcel = async () => {
    const allData = await getAllData();
    if (allData.length > 0) {
      await exportToExcel(headers, allData);
    } else {
      alert("다운로드할 데이터가 없습니다.");
    }
  };

  useEffect(() => {
    getDatas();
  }, [currentPage, searchOption, searchText]);

  return (
    <>
      <DivStyle
        style={{ overflow: "auto" }}
        backgroundColor="#121212"
        height="100vh"
        display="flex"
        flex_direction="column"
        align_items="center"
        marginTop="65px"
      >
        <h2 style={{ color: "white", width: "95%", marginTop: "40px" }}>
          유저 GP 보유 현황
        </h2>
        <DivStyle
          width="55%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <DivStyle
            width="100%"
            display="flex"
            justify_content="flex-end"
            flex_direction="row"
            align_items="center"
            marginRight="20px"
            marginTop="20px"
          >
            <InputFormStyle
              width="30%"
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
            ></InputFormStyle>
            <Icon
              path={mdiMagnify}
              size={1}
              style={{ color: "white", marginRight: "20px" }}
            />
            <ButtonStyle
              onClick={() => exportToExcel(headers, dataList)}
              backgroundColor="#ffffff"
              borderRadius="10px"
              padding="10px 20px"
              color="#000000"
              style={{ marginRight: "10px" }}
            >
              엑셀 다운로드
            </ButtonStyle>
            <ButtonStyle
              onClick={handleExportAllToExcel}
              backgroundColor="#ffffff"
              borderRadius="10px"
              padding="10px 20px"
              color="#000000"
            >
              전체 엑셀 다운로드
            </ButtonStyle>
          </DivStyle>
          <CafePagingTable
            headers={headers}
            currentPage={currentPage}
            dataList={dataList}
          />
          <Page
            currentPage={currentPage}
            totalPages={totalPages}
            dataList={dataList}
            setCurrentPage={setCurrentPage}
          />
        </DivStyle>
      </DivStyle>
    </>
  );
};

export default UserGamePoint;
